import React from 'react';
import TemplatePresetList from '../../components/templatePresets/TemplatePresetList';

const TemplatePresets: React.FC = () => {

    return (<div>
        <TemplatePresetList />
    </div>)
};

export default TemplatePresets;